import "./swipers.js";
import { initReleaseCountdowns } from "../components/release-countdown.js";
import { scheduleHomeLiveStreams } from "./home-live-streams.js";
import { bootHomeHero, destroyHomeHero } from "./home-hero.js";
import { destroyLiveStreamsSection } from "../shared/live-streams-section.js";

window.initHomeReleaseCountdowns = () => initReleaseCountdowns(document);

function bootHomeLiveStreams() {
  if (!document.getElementById('home-live-streams-mount')) {
    return;
  }

  scheduleHomeLiveStreams();
}

document.addEventListener('livewire:navigating', () => {
  destroyHomeHero();
  destroyLiveStreamsSection('home-live-streams-mount');
});

document.addEventListener('livewire:navigated', () => {
  requestAnimationFrame(() => {
    setTimeout(bootHomeLiveStreams, 150);
    bootHomeHero();
  });
});

bootHomeLiveStreams();
bootHomeHero();
